import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { SalesCataloguePage } from '../interfaces/sales/salesCatalogue.interface';

// FW-2A: sellable products and services; open to anyone who can see invoices, quotations or sales orders.
export const SalesCatalogueService = {
  search: async (search = '', kind?: string, page = 0, size = 30): Promise<SalesCataloguePage> => {
    const institutionId = AuthService.getSelectedInstitution();
    const params: Record<string, string | number> = { page, size };
    if (search) params.search = search;
    if (kind) params.kind = kind;
    const r = await axios.get(ENDPOINTS.SALES_CATALOGUE.BY_INSTITUTION(institutionId ?? ''), { params });
    return r.data;
  },
};
